class SaveVolumeUseCase {
    constructor(repository) {
        this.repository = repository
    }
    async execute({
        FK_SECTOR,
        FK_VALVE,
        VOLUMES
    }) {
        // const qtd_rows=await this.repository.count(FK_SECTOR)
        // if(qtd_rows.QTD){
        //     await this.repository.del(FK_SECTOR)
        // }

        let row_values=``

        // Converter array in linhas para serem inseridas no banco de dados
        VOLUMES.forEach((row,index,rows)=>{
          let [TIME,VALUE]=row

          row_values+= `(${FK_VALVE},${FK_SECTOR},'${TIME}','${VALUE}','${VALUE}')${index === rows.length - 1 ? "" : ","}`;
        })

        return await this.repository.save(row_values)
    }
}
export {
    SaveVolumeUseCase
}
